<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-input
          v-model="traceId"
          placeholder="请输入traceId"
          style="width: 200px"
        ></el-input>
        <el-button
          type="primary"
          size="mini"
          style="margin-left: 20px"
          @click="search"
        >
          查询
        </el-button>
      </div>
      <el-table :row-class-name="tableRowClassName" :data="traceLogData">
        <el-table-column
          property="appName"
          label="应用"
          width="120"
        ></el-table-column>
        <el-table-column
          property="time"
          label="时间"
          width="100"
        ></el-table-column>
        <el-table-column property="content" label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column
          property="traceLevel"
          label="级别"
          width="60"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import douYinApi from "../../api/douYin";

export default {
  data() {
    return {
      traceId: "",
      traceLogData: [],
    };
  },
  mounted() {
    const ids = [];
    ids.forEach((id) => {
      douYinApi.retry(
        "ORDER_CUSTOMS_CLEARANCE",
        JSON.stringify({
          stockoutOrderId: id,
          // type: "REVOKE_START",
          type: "REVOKE_SUCCESS",
          time: "2024-06-21 16:56:40",
        })
      );
    });
  },
  methods: {
    search() {
      if (!this.traceId) {
        return;
      }
      douYinApi.listTraceLog(this.traceId).then((res) => {
        this.traceLogData = res.tracelogItems;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      let traceLevel = row.traceLevel;
      if (traceLevel === "DEBUG") {
        return "debug-row";
      } else if (traceLevel === "WRAN") {
        return "warning-row";
      } else if (traceLevel === "INFO") {
        return "success-row";
      } else {
        return "error-row";
      }
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: #fdf5c9;
}

.el-table .debug-row {
  background: #b9f9ba;
}

.el-table .success-row {
  background: #b9f9ba;
}

.el-table .error-row {
  background: #f95c54;
}
</style>
